import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL_TAX_ADJUSTMENT;
const addressUrl = process.env.VUE_APP_API_URL_MAX;
const estoreBaseUrl = process.env.VUE_APP_API_URL_ESTORE;
const taxUrl = process.env.VUE_APP_API_URL_TAX;

const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

httpClient.interceptors.response.use(
  response => response,
  error => errorInterceptor(error)
);

const errorInterceptor = error => {
  if (error && !error.response) {
    if (error.code === "ECONNABORTED") {
      error.response = {
        data: {
          isSucess: false,
          errors: {
            Files: [
              "Request has timed out. Please try again, if issue persists then call our support team"
            ]
          }
        }
      };
    }
  }
  return Promise.reject(error);
};

export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },
  estoreHealthCheck() {
    return httpClient.get(estoreBaseUrl);
  },
  getStreetName(searchText) {
    return httpClient.get(
      `${addressUrl}street-name?startsWith=${encodeURIComponent(searchText)}`
    );
  },
  validateAddress: (streetNumber, streetName) => {
    return httpClient.get(
      addressUrl +
        `validate?streetNo=${encodeURIComponent(streetNumber)}
                              &streetName=${encodeURIComponent(streetName)}`
    );
  },
  getOrderDetails(orderId) {
    return httpClient.get(`${estoreBaseUrl}orders/${orderId}`);
  },
  getPropertyInfo(params) {
    return httpClient.get(`${taxUrl}cert/search?${params}`);
  },
  getReasons(params) {
    const { productClassId, recaptchaToken } = params;
    return httpClient.get(`${baseUrl}listreasons/${productClassId}`, {
      headers: { "recaptcha-token": recaptchaToken }
    });
  },
  getTaxAdjustment({ id, recaptchaToken }) {
    return httpClient.get(`${baseUrl}${id}`, {
      headers: { "recaptcha-token": recaptchaToken }
    });
  },
  fetchProduct(productId) {
    return httpClient.get(`${estoreBaseUrl}product-class/${productId}`);
  },
  postGenericProduct(payload) {
    return httpClient.post(
      `${estoreBaseUrl}orders/add-generic-product-order`,
      payload
    );
  },
  postTaxAdjustment(payload) {
    return httpClient.post(`${baseUrl}create`, payload, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
};
